/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_ButtonInputs */

const vi_irrigation_schedule_button = /** @type {(inputs: Irrigation_Schedule_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lịch tưới`)
};

/**

* @param {Irrigation_Schedule_ButtonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_button = /** @type {((inputs?: Irrigation_Schedule_ButtonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_ButtonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_button(inputs)
});